import { authToken } from '../env'
import axios from '../_client'
import store from '@/store'
import { EventBus } from '@/event-bus'

const LOCATION_URL = store.getters['permissions/url']
const LOCATION_API_TOKEN = store.getters['permissions/apiToken']

const axiosInstaceV1 = axios.create({
  baseURL: `${LOCATION_URL}`,
  headers: {
    'api-token': LOCATION_API_TOKEN
  }
})
axiosInstaceV1.interceptors.response.use(function (response) {
  if (response.data.redirect_to) {
    location.href = response.data.redirect_to
  }
  return response
}, function (error) {
  if (error.response.status === 401) {
    EventBus.$emit('unauthorized')
  }
  if (error.response.status !== 404) {
    EventBus.$emit('show-error-modal', error)
  }
  return Promise.reject(error)
})
export const LocationAPI = {

  getAllLocations(page, limit) {
    return axiosInstaceV1({
      method: 'get',
      url: `/locations`,
      params: {
        page: page || 1,
        limit: limit || 10
      },
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  createLocation(data) {
    return axiosInstaceV1({
      method: 'post',
      url: `/locations`,
      data,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },

  editLocation({ locationId, data }) {
    return axiosInstaceV1({
      method: 'patch',
      url: `/locations/${locationId}`,
      data,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },

  addAddressToLocation({ locationId, data }) {
    return axiosInstaceV1({
      method: 'post',
      url: `/locations/${locationId}/addresses`,
      data,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  updateLocationAddress({ locationId, data }) {
    return axiosInstaceV1({
      method: 'patch',
      url: `/locations/${locationId}/addresses`,
      data,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  updateLocationById(locationId, data) {
    return axiosInstaceV1({
      method: 'patch',
      url: `/locations/${locationId}`,
      data,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },

  deleteLocation({ locationId }) {
    return axiosInstaceV1({
      method: 'delete',
      url: `/locations/${locationId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },

  getLocationHours({ locationId, current = false }) {
    return axiosInstaceV1({
      method: 'get',
      url: `/operating_hours/locations/${locationId}`,
      params: {
        current: current
      },
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },

  addLocationHours({ locationId, data }) {
    console.log(locationId)
    return axiosInstaceV1({
      method: 'post',
      url: `/operating_hours/locations/${locationId}`,
      data,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },

  updateLocationSettings({ locationId, data }) {
    console.log(locationId)
    return axiosInstaceV1({
      method: 'patch',
      url: `/locations/${locationId}/settings`,
      data,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },

  getLocationContactDetails(id) {
    return axiosInstaceV1({
      method: 'GET',
      url: `/contact_details/locations/${id}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  updateLocationContacts(id, data) {
    return axiosInstaceV1({
      method: 'patch',
      url: `/contact_details/${id}`,
      data,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  addLocationContact(data) {
    return axiosInstaceV1({
      method: 'POST',
      url: `/contact_details`,
      data,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },

  deleteLocationContact(id) {
    return axiosInstaceV1({
      method: 'delete',
      url: `/contact_details/${id}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },

  getLocationImages({ locationId }) {
    return axiosInstaceV1({
      method: 'get',
      url: `/location_images/${locationId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },

  addLocationImage({ data }) {
    return axiosInstaceV1({
      method: 'post',
      url: `/location_images`,
      data,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },

  deleteLocationImage({ id }) {
    return axiosInstaceV1({
      method: 'delete',
      url: `/location_images/${id}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  updateLocationImage(locatinImageId, data) {
    return axiosInstaceV1({
      method: 'patch',
      url: `/location_images/${locatinImageId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      },
      data
    })
  },
  getLocationById(id, { address = false, contact = false, settings = false, hours = false, images = false, groups = false } = {}) {
    return axiosInstaceV1({
      method: 'GET',
      url: `locations/${id}?contactDetails=${contact}&address=${address}&settings=${settings}&images=${images}&hours=${hours}&groups=${groups}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  getLocationDeliveryHours(locationId, currentStatus = true) {
    return axiosInstaceV1({
      method: 'GET',
      url: `/delivery_hours/locations/${locationId}?current=${currentStatus}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  updateLocationDeliveryHours(locationId, data) {
    return axiosInstaceV1({
      method: 'POST',
      url: `/delivery_hours/locations/${locationId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      },
      data
    })
  },
  getLocationAddress(locationId) {
    return axiosInstaceV1({
      method: 'GET',
      url: `/locations/${locationId}/addresses`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  getLocationSettings(locationId) {
    return axiosInstaceV1({
      method: 'GET',
      url: `/locations/${locationId}/settings`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  addLocationHolidayHours(locationId, data) {
    return axiosInstaceV1({
      method: 'POST',
      url: `/holidays/locations/${locationId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      },
      data
    })
  },
  getLocationHolidayHours(locationId) {
    return axiosInstaceV1({
      method: 'GET',
      url: `/holidays/locations/${locationId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  updateLocationHoliday(holidayId, data) {
    return axiosInstaceV1({
      method: 'PATCH',
      url: `/holidays/${holidayId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      },
      data
    })
  },
  deleteHoliday(holidayId, data) {
    return axiosInstaceV1({
      method: 'DElETE',
      url: `/holidays/${holidayId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      },
      data
    })
  },
  toggleHolidayHourStatus(id, data) {
    return axiosInstaceV1({
      method: 'PATCH',
      url: `/holidays/${id}/status`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      },
      data
    })
  },
  searchLocations(term) {
    return axiosInstaceV1({
      method: 'GET',
      url: `/locations/search?term=${term}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  getLocationTypes(locationId) {
    return axiosInstaceV1({
      method: 'GET',
      url: `/locations/${locationId}/types`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  addLocationType(locationId, data) {
    return axiosInstaceV1({
      method: 'POST',
      url: `/locations/${locationId}/types`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      },
      data
    })
  },
  removeLocationType(locationId, value) {
    return axiosInstaceV1({
      method: 'DELETE',
      url: `/locations/${locationId}/types?value=${value}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  getLocationPrinters(locationId) {
    return axiosInstaceV1({
      method: 'GET',
      url: `/printers/locations/${locationId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  addPrinterToLocation(data) {
    return axiosInstaceV1({
      method: 'POST',
      url: `/printers`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      },
      data
    })
  },
  deletePrinterFromLocation(printerId) {
    return axiosInstaceV1({
      method: 'DELETE',
      url: `/printers/${printerId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  updatePrinter(printerId, data) {
    return axiosInstaceV1({
      method: 'PATCH',
      url: `/printers/${printerId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      },
      data
    })
  },
  addingDeliveryZone(data) {
    return axiosInstaceV1({
      method: 'POST',
      url: 'delivery_zone',
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      },
      data
    })
  },
  fetchRegions(locationId) {
    return axiosInstaceV1({
      method: 'GET',
      url: `delivery_zone/locations/${locationId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  editRegion(zoneId,data) {
    return axiosInstaceV1({
      method: 'PATCH',
      url: `delivery_zone/${zoneId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      },
      data
    })
  },
  deleteRegion(zoneId) {
    return axiosInstaceV1({
      method: 'DELETE',
      url: `delivery_zone/${zoneId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  fetchCloverToken(authCode, type) {
    return axiosInstaceV1({
      method: 'GET',
      url: `integrators/clover/token?authCode=${authCode}&type=${type}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },

}
